
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import hexsha1 from '../../../static/js/hex-sha1'
import {eventBus} from '../../eventbus'
export default {
name: 'forget',
components: {XInput, Group, XButton, Toast, Countdown, Alert},
data () {
return {
$vue: '',
cellPhone: this.$route.params.usercode,
verificationCode: '',
secretCode: '',
twoPassword: '',
cannotSendCode: false,
verificationContent: '获取验证码',
startCountDown: false,
showCdTime: false,
cdTime: 0,
code: '',
position: 'bottom',
errorText: '',
showSuccess: false,
showPositionValue: false
}
},
methods: {
async sendVerificationCode () {

if (this.cellPhone === '') {
this.showPosition('请输入用户名或手机号码')
}

if (this.cdTime !== 0 && this.cdTime !== undefined) {
return
}

let params = new URLSearchParams()
params.append('USERNAME', this.cellPhone.toString())
let suc = await this.$http.post(this.$vue.getData('FORGET_PSW_SEND_CODE_URL'), params)
if (suc.data.result === '1') {

this.cdTime = 60
this.verificationContent = '已发送'
this.startCountDown = true
this.cannotSendCode = true
this.showCdTime = true
} else {
this.showPosition('用户不存在')
}
},

finishCountDown () {
this.showCdTime = false
this.verificationContent = '发送验证码'
this.startCountDown = false
this.cannotSendCode = false
},
define () {
if (this.twoPassword !== this.secretCode) {
this.showPosition('两次密码不一致，请重新输入')
return
}

this.$validator.validateAll().then((result) => {
if (!result) {
if (this.error.has('cellPhone')) {
this.showPosition(this.error.first('cellPhone'))
return
}
if (this.error.has('verificationCode')) {
this.showPosition(this.error.first('verificationCode'))
return
}
if (this.error.has('secretCode')) {
this.showPosition(this.error.first('secretCode'))
}
} else {
this.submitForgetPSW()
}
})
},

async submitForgetPSW () {

eventBus.$emit('showLoading', true, '正在提交')
let params = new URLSearchParams()
params.append('verificationCode', this.verificationCode)
params.append('USERNAME', this.cellPhone.toString())
params.append('newPsw', hexsha1.hex_sha1(this.secretCode))
let suc = await this.$http.post(this.$vue.getData('FORGET_PSW_SUBMIT_URL'), params)

eventBus.$emit('showLoading', false)
if (suc.data.result === '1') {
this.showSuccess = true
setTimeout(() => {
this.showSuccess = false
}, 3000)
} else {
this.showPosition(suc.data.data)
}
},
editSuc () {
this.$router.push({name: 'Login'})
},
showPosition (text) {
this.errorText = text
this.showPositionValue = true
}
},
beforeMount () {
this.$vue = this
}
}



// WEBPACK FOOTER //
// ./src/components/login/forget.vue